import clientProfileImageIcon from "../../../assets/clientProfileImage.png";
import {Card} from "antd";
import React, {useState} from "react";
import "../../../styles/EmployeeInfoLayout.css";

export default function CardComponent({employee}){
    const base_url = process.env.REACT_APP_BASE_URL;
    const [employeeImageError, setEmployeeImageError] = useState(false);
    const handleImageError = () => {
        // When there's an error loading the employee image, set the employeeImageError state to true.
        setEmployeeImageError(true);
    };
    return (
        <>
            <Card
                bordered={true}
                className="custom-card"
                size="small"
                style={{ fontSize: "11px" }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginTop: "10px",
                        flexDirection: "column"
                    }}
                >
                    <div style={{ width: "100%" }}>
                        <div className="image-container">
                            {employeeImageError || employee.passport_size_photo === null ? (
                                <img
                                    src={clientProfileImageIcon}
                                    alt="EmployeeImage"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                    }}
                                    onError={handleImageError}
                                />
                            ) : (
                                <img
                                    src={
                                        `${base_url}/client/${employee.user_id}/` +
                                        employee.passport_size_photo
                                    }
                                    alt="EmployeeImage"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                    }}
                                    onError={handleImageError}
                                />
                            )}
                            {employee.designation ? <span className="image-designation">{employee.designation}</span> : ''}
                        </div>
                    </div>
                    <div style={{width: "100%", height: "1px", background: "#cccccc", margin: "10px 0px"}}/>
                    <div
                        className="employee-info"
                        style={{
                            width: "100%",
                            marginLeft: "4px",
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column",
                        }}
                    >
                                  <span className="text-title">
                                      {employee.name}
                                    </span>
                        {employee.employee_id ? (
                            <span className="text-title">
                                      <strong>ID :</strong>{" "}
                                {employee.employee_id}
                                    </span>
                        ) : (
                            <span className="text-title">
                                      <strong>ID :</strong> -
                                    </span>
                        )}
                        {employee.type ? (
                            <span className="text-title">
                                      <strong>Type :</strong> {employee.type.charAt(0).toUpperCase() + employee.type.slice(1)}
                                    </span>
                        ) : (
                            <span className="text-title">
                                      <strong>Type :</strong>
                                    </span>
                        )}
                        {employee.department ? (
                            <span className="text-title">
                                      <strong>Dept :</strong>{" "}
                                {employee.department}
                                    </span>
                        ) : (
                            <span className="text-title">
                                      <strong>Dept :</strong>
                                    </span>
                        )}
                    </div>
                </div>
            </Card>
        </>
    )
}